import React from "react";
import { Form, FormControlProps as RsuiteFormControlProps } from "rsuite";
import styled, { createGlobalStyle } from "styled-components";

interface StyledFormControlProps {
    width?: number;
}

const StyledFormControl = styled(Form.Control) <StyledFormControlProps>`
    && {
        background-color: var(--color-border);
        color: var(--color-text);
        border: 1px solid var(--color-border-light);
        border-radius: 8px;
    }

    &&.rs-input {
        /* width: 100% */
        width: ${props => props.width ?? 220}px;
        min-width: ${props => props.width ?? 220}px;
    }

    &&:disabled {
        /* width: 100% */
        background-color: var(--color-bg);
        border: 1px solid var(--color-border);
    }

    &&.rs-picker.rs-picker-select {
        /* width: 100%; */
        width: ${props => props.width ?? 220}px;
        min-width: ${props => props.width ?? 220}px;
    }

    &&.rs-picker.rs-picker-daterange .rs-input-group {
        width: ${props => props.width ?? 220}px;
        min-width: ${props => props.width ?? 220}px;
    }


    /* &&.rs-input:hover:not(:disabled) {
        border: 1px solid #d1d5db;
    } */

    && .rs-picker-toggle.rs-btn {
        background-color: var(--color-border) !important;
        color: var(--color-text);
        border: 1px solid var(--color-border-light);
        border-radius: 8px;
    }

    && .rs-picker-input-group.rs-input-group {
        background-color: var(--color-border);
        color: var(--color-text);
        border: 1px solid var(--color-border-light);
    }

    &&:disabled .rs-picker-toggle.rs-btn {
        background-color: var(--color-bg) !important;
        color: var(--color-text-dark);
        border: 1px solid var(--color-border);
    }

    &&.rs-picker-disabled .rs-picker-input-group.rs-input-group {
        background-color: var(--color-bg) !important;
        color: var(--color-text-dark);
        border: 1px solid var(--color-border);
    }

    && .rs-picker-label.rs-input-group-addon {
        color: var(--color-text);
    }

    && .rs-input-group-addon.rs-input-group-addon-disabled {
        color: var(--color-text-dark);
    }

    && .rs-date-range-input.rs-input {
        background-color: var(--color-border);
        color: var(--color-text);
        /* border: 1px solid var(--color-border-light); */
    }

    &&.rs-picker-disabled .rs-date-range-input.rs-input {
        background-color: var(--color-bg);
        color: var(--color-text-dark);
    }

    &&.rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value {
        color: var(--color-text);
    }

    && .rs-stack-item .rs-picker-toggle-label {
        color: var(--color-text);
    }

    && .rs-stack-item .rs-picker-toggle-value {
        font-weight: 600;
    }

    &&.rs-input:focus,
    &&.rs-picker:not(.rs-picker.rs-picker-daterange):focus,
    &&.rs-input:hover,
    &&.rs-picker:not(.rs-picker.rs-picker-daterange):hover {
        box-shadow: inset 0px 0 0px 1px var(--color-button);
        border-color: var(--color-button);
        border-width: 1px;
        /* box-shadow: 0 0 0 3px var(--color-button-hover); */ 
    }

    &&:disabled.rs-input:focus,
    &&:disabled.rs-picker:not(.rs-picker.rs-picker-daterange):focus,
    &&:disabled.rs-input:hover,
    &&:disabled.rs-picker:not(.rs-picker.rs-picker-daterange):hover {
        box-shadow: inset 0px 0 0px 1px var(--color-button-hover);
        border-color: var(--color-button-hover);
        border-width: 1px;
        /* box-shadow: 0 0 0 3px var(--color-button-hover); */ 
    }
    

    &&.rs-picker.rs-picker-daterange:focus,
    &&.rs-picker.rs-picker-daterange:hover,
    &&.rs-picker.rs-picker-daterange:hover .rs-picker-input-group {
        box-shadow: inset -4px 0 0px -4px var(--color-button);
        border-color: var(--color-button);
        border-width: 1px;
        /* box-shadow: 0 0 0 3px var(--color-button-hover); */
    }
    &&.rs-picker.rs-picker-daterange:focus,
    &&.rs-picker.rs-picker-daterange:hover,
    &&.rs-picker.rs-picker-daterange:hover input {
        box-shadow: inset 4px 0 0px -4px var(--color-button);
        border-color: var(--color-button);
        border-width: 1px;
    }

    &&.rs-picker.rs-picker-daterange.rs-picker-disabled:focus,
    &&.rs-picker.rs-picker-daterange.rs-picker-disabled:hover,
    &&.rs-picker.rs-picker-daterange.rs-picker-disabled:hover .rs-picker-input-group {
        box-shadow: inset -4px 0 0px -4px var(--color-button-hover);
        border-color: var(--color-button-hover);
        border-width: 1px;
        /* box-shadow: 0 0 0 3px var(--color-button-hover); */
    }
    &&.rs-picker.rs-picker-daterange.rs-picker-disabled:focus,
    &&.rs-picker.rs-picker-daterange.rs-picker-disabled:hover,
    &&.rs-picker.rs-picker-daterange.rs-picker-disabled:hover input {
        box-shadow: inset 4px 0 0px -4px var(--color-button-hover);
        border-color: var(--color-button-hover);
        border-width: 1px;
    }
`;

const GlobalStyles = createGlobalStyle`
    .rs-picker:not(.rs-picker-disabled):hover {
        border-color: var(--color-text-dark);
    }

    .rs-picker-select-menu.rs-picker-popup {
        background-color: var(--color-border) !important;
    }

    .rs-picker-select-menu.rs-picker-popup .rs-picker-list-item span {
        color: var(--color-text-dark);
    }

    .rs-picker-select-menu.rs-picker-popup .rs-picker-list-item[aria-selected="true"] span {
        background-color: var(--color-border-light);
        color: var(--color-text);
    }
`;

type BaseFormControlProps = RsuiteFormControlProps & {
    as?: React.ElementType;
    [key: string]: any;
};

const FormControl: React.FC<BaseFormControlProps> = ({
    as,
    ...rest
}) => (
    <>
        <GlobalStyles />
        <StyledFormControl accepter={as} {...rest} />
    </>
);

export default FormControl;